import { createContext } from "react";

export const ServiceApprovalModalContext = createContext();
